import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { getFarmsList } from "../../../actions/Farms/farms";
import MultiSelectFilter from "./MultiSelectFilter/MultiSelectFilter";

const FarmMultiSelectFilter = ({
  actions: { fetchList },
  list,
  isFetching,
  reportsReducerNeedToRefactor,
  ...extraProps
}) => {
  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const options = useMemo(
    () =>
      list
        .filter(item => !item.archived)
        .map(item => ({
          key: item.id,
          text: item.name.trim(),
          value: item.name.trim()
        })),
    [list]
  );

  return (
    <MultiSelectFilter
      disabled={reportsReducerNeedToRefactor.isFetching}
      options={options}
      numbers={false}
      loading={reportsReducerNeedToRefactor.isFetching}
      {...extraProps}
    />
  );
};

const mapStateToProps = state => {
  const {
    reports: { reportsReducerNeedToRefactor },
    farms: {
      isFetching,
      data: { content }
    }
  } = state;

  return {
    reportsReducerNeedToRefactor,
    list: content,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchList: getFarmsList
    },
    dispatch
  )
});

FarmMultiSelectFilter.propTypes = {
  isFetching: PropTypes.bool,
  list: PropTypes.array,
  actions: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FarmMultiSelectFilter);
